import { Ticket } from '@hpx-it/queue-client';
import { Button } from '@mui/material';
import { useState } from 'react';

import { RescheduleDialog } from './RescheduleDialog';
import { getRescheduleButtonStyle } from './style';

type RescheduleButtonProps = {
  ticket: Ticket;
  setTicket: (ticket: Ticket) => void;
};

export const RescheduleButton = ({
  ticket,
  setTicket,
}: RescheduleButtonProps) => {
  const [dialogOpen, setDialogOpen] = useState(false);

  return (
    <>
      <Button
        {...getRescheduleButtonStyle()}
        onClick={() => setDialogOpen(true)}
      >
        Reschedule
      </Button>

      <RescheduleDialog
        ticket={ticket}
        setTicket={setTicket}
        open={dialogOpen}
        setOpen={setDialogOpen}
      />
    </>
  );
};
